import { ActivatedRoute, CanActivateFn } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, map, of, take } from 'rxjs';
import { OAuthStorage } from 'angular-oauth2-oidc';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../core/services/auth/auth.service';


export const reportGuard: CanActivateFn = (route, state) => {
  const http = inject(HttpClient);
  const oAuthStorage = inject(OAuthStorage);
  const authService = inject(AuthService);

  const url = new URL(state.url, window.location.origin);
  // Split the pathname into segments
  const segments = url.pathname.split('/');
  // Extract the `userid` and `guid` values
  const userIdIndex = segments.indexOf('userid');
  const userId = userIdIndex !== -1 ? segments[userIdIndex + 1] : null;

  const hashIndex = segments.indexOf('hash');
  const hash = hashIndex !== -1 ? segments[hashIndex + 1] : null;

  const checksumIndex = segments.indexOf('guid');
  const checksum = checksumIndex !== -1 ? segments[checksumIndex + 1] : null;

  const reportsIdIndex = segments.indexOf('report');
  const reportsId = reportsIdIndex !== -1 ? segments[reportsIdIndex + 1] : null;

  let body = new HttpParams()
  body = body.append('client_id', 'hEoUCt2WCJ')
  body = body.append('client_secret', '0cd9282bd8006b3207c25e1d2f9908828566a9dc1d9fa1e60b6fd9a514f741c7')
  body = body.append('grant_type', 'report_client_credentials')
  body = body.append('scope', 'generate_reportpdf')
  body = body.append('sub', userId ?? 3)
  body = body.append('tenant',  authService.tenant)
  body = body.append('reportsid',  reportsId ?? "")
  body = body.append('hash',  hash ?? "")
  body = body.append('checksum',  checksum ?? "")

  let headers = new HttpHeaders();
  headers = headers.append('Content-Type', 'application/x-www-form-urlencoded');
  return http.post<any>(`${environment.idpUri}/connect/token`, body.toString(), { headers }).pipe(take(1), map(response => {
    oAuthStorage.setItem('report_access_token', response['access_token']);
    return true;
  }), catchError(err => of(false)));
};